import { Applications } from "./applications";
import { Archive } from "./archive";
import { Base } from "./base";
import { Branch } from "./branch";
import { Citizenship } from "./citizenship";
import { Company } from "./company";
import { Country } from "./country";
import { Languages } from "./languages";
import { DifferentLocation } from "./location";
import { Picture } from "./picture";
import { Team } from "./team";
import { Timezone } from "./timezone";
import { Roles, User } from "./user";

export enum MemberCertificationStatus {
  APPROVED = "Approved",
  WAITING = "Waiting approval",
}

export type MemberCertification = {
  id?: number;
  description: string;
  url: string | null;
  reviewDate: string | null;
  expireDate: string | null;
  isApproved: boolean;
  archiveId: number | null;
  archive: Archive | null;
  status: MemberCertificationStatus;
  /**
   * Property used only on frontend side to identificate the object inside grid.
   */
  randomUuid?: string;
};

export enum MemberAvailabilityType {
  ABSENCE = "Absence",
  ILLNESS = "Illness",
  TRAINING = "Training",
}

export type MemberAvailability = {
  id?: number;
  type: string;
  isCancelled?: boolean;
  isAllDay?: boolean;
  startDate: string | Date;
  endDate?: string | Date;
  startTime?: string | Date;
  endTime?: string | Date;
  createdById: number;
  createdBy?: Partial<User>;

  /**
   * Property used only on frontend side to identificate the object inside grid.
   */
  randomUuid?: string;
};

export type MemberTimesheet = {
  id?: number;

  taskType?: string;
  teamId?: number;
  taskId?: number;

  arriveAtResidence?: Date;
  breakFrom?: Date;
  backFromBreak?: Date;
  leavingResidence?: Date;
  time?: Date;
  arrivedBackWarehouse?: Date;

  /**
   * Property used only on frontend side to identificate the object inside grid.
   */
  randomUuid?: string;
};

export interface Member extends Base {
  username?: string;
  picture?: Picture;
  status: string;
  nickname?: string;
  code?: string;
  firstName: string;
  lastName: string;
  fullName?: string;
  email?: string;
  mobile: string;
  phoneNumber?: string;
  dateOfBirth?: string;
  startEmploymentDate?: string;
  endEmploymentDate?: string;
  language?: Languages;
  languageId?: number;
  countryId?: number;
  country?: Country;
  citizenshipId?: number;
  citizenship?: Citizenship;
  license?: string;
  jobTitle?: string;
  gender?: string;
  type?: string;
  belongsToASubcontractor?: boolean;
  company?: Company;
  location?: DifferentLocation;
  locationId?: number;
  roleId: number;
  role: Roles;
  typeUser: string;
  applications?: Applications[];
  leader?: boolean;

  emergencyName?: string;
  emergencyPhone?: string;
  emergencyRelationship?: string;
  position?: string;
  residencyStatus?: string;
  timezone?: Timezone;
  timezoneId?: number;
  branches?: Branch[];
  teamId?: number;
  team?: Team;
  subcontractor?: any | null;
  subcontractorId?: number | null;
  ratePerHour?: number;

  availabilities?: MemberAvailability[];
  certifications?: MemberCertification[];
}
